
import Button from '../../components/base/Button';
import { Link } from 'react-router-dom';
import SEOHead from '../../components/seo/SEOHead';

export default function About() {
  const teamMembers = [
    {
      name: 'Dr. Sandhya',
      designation: 'General and Cosmetic Dentist',
      image: 'https://toothdoctor.in/wp-content/uploads/elementor/thumbs/sandhiya-q8ywhy4exkvzh53f4jl50qjghrfs6dlutl3rqdr8hy.jpg',
      description: 'Dr. Sandhya is a highly skilled and experienced dentist who leads the team at Tooth Doctor Clinic. With a passion for dentistry and a commitment to patient care, she has established herself as a trusted dental professional in the community.'
    },
    {
      name: 'Dr. N R Shrinivaasan',
      designation: 'M.D.S., Consultant Orthodontist Professor and Head of the department Department of orthodontics Dhanalakshmi Srinivasan dental college',
      image: 'https://toothdoctor.in/wp-content/uploads/2023/07/tooth-doctor-5-768x779.jpg',
      description: 'Specialist in orthodontics with extensive experience in teeth alignment and bite correction treatments.'
    },
    {
      name: 'Dr. Shanmugasundaram',
      designation: 'MDS, FIBOMS, MBA (HOSPITAL Management), FAOCMF(GERMANY)',
      image: 'https://toothdoctor.in/wp-content/uploads/2023/07/WhatsApp-Image-2023-07-07-at-11.13.28-AM-768x779.jpeg',
      description: 'Expert in oral and maxillofacial surgery with international qualifications and hospital management expertise.'
    },
    {
      name: 'Dr. K. Dhanadivya',
      designation: 'Consultant Periodontist Senior Lecturer, Department of Periodontics, Sri Ramachandra Dental college and Hospital, SRIHER',
      image: 'https://toothdoctor.in/wp-content/uploads/2023/07/tooth-doctor-768x779.jpg',
      description: 'Specialist in periodontics focusing on gum health and supporting structures of teeth.'
    },
    {
      name: 'Dr. Suthanraj.AK',
      designation: 'MDS (OMFS) Association Professor Karpaga Vinayaga Institute of Dental Sciences',
      image: 'https://toothdoctor.in/wp-content/uploads/2023/07/tooth-doctor-2-768x779.jpg',
      description: 'Expert in oral and maxillofacial surgery with academic and clinical experience.'
    },
    {
      name: 'Dr. S. Riyaz Mohammed',
      designation: 'Periodontist & ORAL implantologist Member- IPS',
      image: 'https://toothdoctor.in/wp-content/uploads/2024/09/WhatsApp-Image-2024-09-23-at-7.53.13-PM-150x150.jpeg',
      description: 'Specialist in periodontics and oral implantology with membership in professional societies.'
    }
  ];

  const whyChooseUs = [
    {
      icon: 'ri-user-heart-line',
      title: 'Experienced Specialists',
      description: 'A team of highly qualified dentists and consultants with expertise in every dental field — from implants to orthodontics, pediatric dentistry to smile design.'
    },
    {
      icon: 'ri-computer-line',
      title: 'Advanced Dental Technology',
      description: 'We use cutting-edge equipment like digital X-rays, rotary endodontics, intraoral scanners, and dental lasers for accuracy and comfort.'
    },
    {
      icon: 'ri-heart-pulse-line',
      title: 'Pain-Free Treatments',
      description: 'Modern anesthesia techniques, laser dentistry, and gentle care ensure stress-free procedures for every patient.'
    },
    {
      icon: 'ri-shield-check-line',
      title: 'Hygienic & Comfortable Clinic',
      description: 'Our clinic follows strict sterilization protocols and offers a calm, comfortable atmosphere to help you relax during your visit.'
    },
    {
      icon: 'ri-user-smile-line',
      title: 'Personalized Care',
      description: 'Every smile is unique. We listen, understand, and design personalized treatment plans for your dental and aesthetic goals.'
    }
  ];

  const specialties = [
    'Dental Implants & Full Mouth Rehabilitation',
    'Cosmetic & Smile Design Dentistry',
    'Root Canal & Endodontic Treatments',
    'Pediatric (Child) Dentistry',
    'Orthodontics – Braces & Clear Aligners',
    'Gum & Laser Treatments',
    'Oral Surgery & Wisdom Tooth Extraction',
    'Preventive & General Dentistry'
  ];

  const jsonLd = {
    "@context": "https://schema.org",
    "@type": "WebPage",
    "name": "About Us - The Tooth Doctor Advanced Dental Care Centre",
    "description": "Learn about The Tooth Doctor's expert dental team, advanced technology, and commitment to providing exceptional dental care in Chennai.",
    "url": `${import.meta.env.VITE_SITE_URL || 'https://example.com'}/about`,
    "mainEntity": {
      "@type": "AboutPage",
      "about": {
        "@type": "DentalClinic",
        "name": "The Tooth Doctor - Advanced Dental Care Centre",
        "foundingDate": "2010",
        "founder": {
          "@type": "Person",
          "name": "Dr. Sandhya",
          "jobTitle": "Chief Dental Surgeon & Founder",
          "worksFor": {
            "@type": "DentalClinic",
            "name": "The Tooth Doctor"
          }
        }
      }
    },
    "breadcrumb": {
      "@type": "BreadcrumbList",
      "itemListElement": [
        {
          "@type": "ListItem",
          "position": 1,
          "name": "Home",
          "item": `${import.meta.env.VITE_SITE_URL || 'https://example.com'}`
        },
        {
          "@type": "ListItem",
          "position": 2,
          "name": "About Us",
          "item": `${import.meta.env.VITE_SITE_URL || 'https://example.com'}/about`
        }
      ]
    }
  };

  return (
    <div className="min-h-screen">
      <SEOHead
        title="The Tooth Doctor | Expert Dental Team in Chennai"
        description="Learn about The Tooth Doctor's expert dental team, advanced technology, and commitment to providing exceptional dental care in Chennai. Meet our experienced specialists."
        keywords="about tooth doctor, dental team Chennai, expert dentists, dental clinic history, dental specialists Thiruverkadu"
        canonical={`${import.meta.env.VITE_SITE_URL || 'https://example.com'}/about`}
        ogTitle="The Tooth Doctor | Expert Dental Team in Chennai"
        ogDescription="Learn about The Tooth Doctor's expert dental team, advanced technology, and commitment to providing exceptional dental care in Chennai. Meet our experienced specialists."
        ogUrl={`${import.meta.env.VITE_SITE_URL || 'https://example.com'}/about`}
        ogImage={`${import.meta.env.VITE_SITE_URL || 'https://example.com'}/og-about.jpg`}
        jsonLd={jsonLd}
      />
      {/* Hero Section */}
      <section 
        className="relative py-32 bg-cover bg-center bg-no-repeat"
        style={{
          backgroundImage: `linear-gradient(rgba(1, 43, 83, 0.8), rgba(1, 43, 83, 0.6)), url('https://readdy.ai/api/search-image?query=Happy%20patient%20with%20beautiful%20smile%20after%20dental%20treatment%2C%20professional%20dental%20clinic%20background%2C%20confident%20woman%20smiling%2C%20modern%20dental%20care%20environment%2C%20bright%20and%20welcoming%20atmosphere&width=1920&height=800&seq=about-hero-new&orientation=landscape')`
        }}
      >
        <div className="max-w-7xl mx-auto px-4 sm:px-6 lg:px-8 text-center text-white">
          <h1 className="text-5xl md:text-7xl font-bold mb-6">Creating Confident Smiles</h1>
          <p className="text-2xl md:text-3xl mb-8 font-light">with Compassion & Expertise</p>
          <Link to="/contact">
            <Button 
              size="lg" 
              className="bg-teal-500 hover:bg-teal-600 text-white px-8 py-4 text-lg"
            >
              Book Your Appointment Today
            </Button>
          </Link>
        </div>
      </section>

      {/* Who We Are */}
      <section className="py-20 bg-white">
        <div className="max-w-7xl mx-auto px-4 sm:px-6 lg:px-8">
          <div className="grid grid-cols-1 lg:grid-cols-2 gap-12 items-center">
            <div>
              <div className="flex items-center mb-6">
                <div className="w-12 h-12 bg-blue-100 rounded-full flex items-center justify-center mr-4">
                  <span className="text-2xl">💙</span>
                </div>
                <h2 className="text-4xl font-bold text-gray-900">Who We Are</h2>
              </div>
              
              <p className="text-lg text-gray-600 mb-6 leading-relaxed">
                Welcome to <strong>The Tooth Doctor – Advanced Dental Care Centre</strong>, one of Chennai's leading dental clinics located in Thiruverkadu.
              </p>
              
              <p className="text-lg text-gray-600 mb-6 leading-relaxed">
                We are a multi-specialty dental center committed to delivering exceptional care with precision, comfort, and trust. 
                Our goal is simple — to make every smile healthier, brighter, and more confident through advanced dental technology and personalized attention.
              </p>
              
              <p className="text-lg text-gray-600 mb-8 leading-relaxed">
                At The Tooth Doctor, dentistry goes beyond treatment — it's about building lasting relationships and helping patients feel comfortable, informed, and confident in their dental health.
              </p>

              <div className="bg-blue-50 p-6 rounded-xl border-l-4 border-[#012B53]">
                <h3 className="text-xl font-semibold text-[#012B53] mb-3 flex items-center">
                  <span className="text-2xl mr-3">🌟</span>
                  Our Philosophy
                </h3>
                <p className="text-lg text-gray-700 italic mb-3">"We don't just treat teeth — we care for people."</p>
                <p className="text-gray-600">
                  Every patient who walks through our doors is treated like family. We believe in ethical, transparent, and compassionate dentistry, ensuring that each treatment plan is tailored to your unique needs and comfort.
                </p>
              </div>
            </div>

            <div className="relative">
              <img 
                src="https://static.readdy.ai/image/9921b96583d8c2e46a2d40cbefc3b198/0e4c8c2f96f7c8d68e3c212d95057863.jfif" 
                alt="The Tooth Doctor Clinic Interior"
                className="w-full rounded-2xl shadow-2xl"
              />
            </div>
          </div>
        </div>
      </section>

      {/* Vision & Mission */}
      <section className="py-20 bg-gray-50">
        <div className="max-w-7xl mx-auto px-4 sm:px-6 lg:px-8">
          <div className="grid grid-cols-1 lg:grid-cols-2 gap-12">
            {/* Vision */}
            <div className="bg-white rounded-2xl p-8 shadow-lg">
              <div className="flex items-center mb-6">
                <div className="w-12 h-12 bg-blue-100 rounded-full flex items-center justify-center mr-4">
                  <span className="text-2xl">🧠</span>
                </div>
                <h3 className="text-3xl font-bold text-gray-900">Our Vision</h3>
              </div>
              <p className="text-lg text-gray-600 leading-relaxed">
                To be Chennai's most trusted dental care destination — where innovation meets compassion, and every smile receives expert attention and genuine care.
              </p>
            </div>

            {/* Mission */}
            <div className="bg-white rounded-2xl p-8 shadow-lg">
              <div className="flex items-center mb-6">
                <div className="w-12 h-12 bg-teal-100 rounded-full flex items-center justify-center mr-4">
                  <span className="text-2xl">🎯</span>
                </div>
                <h3 className="text-3xl font-bold text-gray-900">Our Mission</h3>
              </div>
              <ul className="space-y-3 text-gray-600">
                <li className="flex items-start">
                  <i className="ri-check-line text-teal-500 text-xl mr-3 mt-1"></i>
                  <span>Deliver pain-free, advanced dental care with precision and hygiene</span>
                </li>
                <li className="flex items-start">
                  <i className="ri-check-line text-teal-500 text-xl mr-3 mt-1"></i>
                  <span>Provide a comprehensive range of dental treatments under one roof</span>
                </li>
                <li className="flex items-start">
                  <i className="ri-check-line text-teal-500 text-xl mr-3 mt-1"></i>
                  <span>Make world-class dental care affordable and accessible to all</span>
                </li>
                <li className="flex items-start">
                  <i className="ri-check-line text-teal-500 text-xl mr-3 mt-1"></i>
                  <span>Promote oral health awareness through patient education and preventive dentistry</span>
                </li>
              </ul>
            </div>
          </div>
        </div>
      </section>

      {/* Why Choose Us */}
      <section className="py-20 bg-white">
        <div className="max-w-7xl mx-auto px-4 sm:px-6 lg:px-8">
          <div className="text-center mb-16">
            <div className="flex items-center justify-center mb-6">
              <div className="w-12 h-12 bg-yellow-100 rounded-full flex items-center justify-center mr-4">
                <span className="text-2xl">🪄</span>
              </div>
              <h2 className="text-4xl font-bold text-gray-900">Why Choose The Tooth Doctor</h2>
            </div>
            <p className="text-xl text-gray-600 max-w-3xl mx-auto">
              Experience the difference with our comprehensive approach to dental care
            </p>
          </div>

          <div className="grid grid-cols-1 md:grid-cols-2 lg:grid-cols-3 gap-8">
            {whyChooseUs.map((item, index) => (
              <div key={index} className="bg-white rounded-xl p-8 shadow-lg hover:shadow-xl transition-shadow duration-300 border border-gray-100">
                <div className="w-16 h-16 bg-[#012B53] rounded-full flex items-center justify-center mx-auto mb-6">
                  <i className={`${item.icon} text-white text-2xl`}></i>
                </div>
                <h3 className="text-xl font-semibold text-gray-900 mb-4 text-center">{item.title}</h3>
                <p className="text-gray-600 text-center leading-relaxed">{item.description}</p>
              </div>
            ))}
          </div>
        </div>
      </section>

      {/* Founder Section */}
      <section className="py-20 bg-gradient-to-r from-[#012B53] to-blue-700 text-white">
        <div className="max-w-7xl mx-auto px-4 sm:px-6 lg:px-8">
          <div className="grid grid-cols-1 lg:grid-cols-2 gap-12 items-center">
            <div className="text-center lg:text-left">
              <div className="flex items-center justify-center lg:justify-start mb-6">
                <div className="w-12 h-12 bg-white/20 rounded-full flex items-center justify-center mr-4">
                  <span className="text-2xl">💎</span>
                </div>
                <h2 className="text-4xl font-bold">Meet Our Founder</h2>
              </div>
              
              <h3 className="text-3xl font-bold mb-2">Dr. Sandhya</h3>
              <p className="text-xl text-blue-200 mb-4">General & Cosmetic Dentist</p>
              <p className="text-lg text-blue-100 mb-6">Chief Dental Surgeon & Founder</p>
              
              <p className="text-lg mb-8 leading-relaxed">
                With years of clinical experience and advanced training, Dr. Sandhya established The Tooth Doctor with the vision of providing ethical, world-class dental care in a patient-first environment.
              </p>
              
              <div className="bg-white/10 p-6 rounded-xl border-l-4 border-teal-400">
                <p className="text-xl italic mb-2">"The best smiles are built on trust, comfort, and quality care."</p>
                <p className="text-blue-200">- Dr. Sandhya</p>
              </div>
            </div>

            <div className="relative">
              <div className="relative rounded-2xl overflow-hidden shadow-2xl">
                <img 
                  src="https://toothdoctor.in/wp-content/uploads/2023/07/sandhya-962x1024.png" 
                  alt="Dr. Sandhya - Founder & Chief Dentist"
                  className="w-full h-[600px] object-cover"
                />
                <div className="absolute inset-0 bg-gradient-to-t from-[#012B53]/20 to-transparent"></div>
              </div>
            </div>
          </div>
        </div>
      </section>

      {/* Core Specialties */}
      <section className="py-20 bg-gray-50">
        <div className="max-w-7xl mx-auto px-4 sm:px-6 lg:px-8">
          <div className="text-center mb-16">
            <div className="flex items-center justify-center mb-6">
              <div className="w-12 h-12 bg-teal-100 rounded-full flex items-center justify-center mr-4">
                <span className="text-2xl">🧩</span>
              </div>
              <h2 className="text-4xl font-bold text-gray-900">Our Core Specialties</h2>
            </div>
            <p className="text-xl text-gray-600 max-w-3xl mx-auto">
              Comprehensive dental care services under one roof
            </p>
          </div>

          <div className="grid grid-cols-1 md:grid-cols-2 lg:grid-cols-4 gap-6">
            {specialties.map((specialty, index) => (
              <div key={index} className="bg-white rounded-xl p-6 shadow-lg hover:shadow-xl transition-shadow duration-300 text-center">
                <div className="w-12 h-12 bg-teal-500 rounded-full flex items-center justify-center mx-auto mb-4">
                  <i className="ri-tooth-line text-white text-xl"></i>
                </div>
                <h3 className="text-lg font-semibold text-gray-900">{specialty}</h3>
              </div>
            ))}
          </div>
        </div>
      </section>

      {/* Team Section */}
      <section className="py-20 bg-white">
        <div className="max-w-7xl mx-auto px-4 sm:px-6 lg:px-8">
          <div className="text-center mb-16">
            <h2 className="text-4xl font-bold text-gray-900 mb-4">Meet Our Expert Team</h2>
            <p className="text-xl text-gray-600 max-w-3xl mx-auto">
              Our team of experienced dentists and specialists are dedicated to providing you with the best possible care
            </p>
          </div>

          <div className="grid grid-cols-1 md:grid-cols-2 lg:grid-cols-3 gap-8">
            {teamMembers.map((member, index) => (
              <div key={index} className="bg-white rounded-xl shadow-lg overflow-hidden hover:shadow-xl transition-shadow duration-300">
                <div className="aspect-square overflow-hidden">
                  <img 
                    src={member.image} 
                    alt={member.name}
                    className="w-full h-full object-cover hover:scale-105 transition-transform duration-300"
                  />
                </div>
                <div className="p-6">
                  <h3 className="text-xl font-semibold text-gray-900 mb-2">{member.name}</h3>
                  <p className="text-[#012B53] font-medium mb-3">{member.designation}</p>
                  <p className="text-gray-600 text-sm">{member.description}</p>
                </div>
              </div>
            ))}
          </div>
        </div>
      </section>

      {/* Contact CTA */}
      <section className="py-20 bg-gradient-to-r from-teal-500 to-blue-600 text-white">
        <div className="max-w-7xl mx-auto px-4 sm:px-6 lg:px-8 text-center">
          <div className="flex items-center justify-center mb-6">
            <div className="w-12 h-12 bg-white/20 rounded-full flex items-center justify-center mr-4">
              <span className="text-2xl">📍</span>
            </div>
            <h2 className="text-4xl font-bold">Visit Us Today</h2>
          </div>
          
          <div className="max-w-4xl mx-auto mb-12">
            <h3 className="text-2xl font-semibold mb-4">The Tooth Doctor – Advanced Dental Care Centre</h3>
            <p className="text-xl mb-6">Thiruverkadu, Chennai</p>
            
            <div className="grid grid-cols-1 md:grid-cols-3 gap-8 text-center">
              <div>
                <i className="ri-phone-line text-3xl mb-3"></i>
                <p className="text-lg font-semibold">Call / WhatsApp</p>
                <a href="tel:+916369090441" className="text-yellow-300 hover:text-white transition-colors">
                  +91 63690 90441
                </a>
              </div>
              <div>
                <i className="ri-global-line text-3xl mb-3"></i>
                <p className="text-lg font-semibold">Website</p>
                <a href="https://www.toothdoctor.in" target="_blank" rel="noopener noreferrer" className="text-yellow-300 hover:text-white transition-colors">
                  www.toothdoctor.in
                </a>
              </div>
              <div>
                <i className="ri-calendar-line text-3xl mb-3"></i>
                <p className="text-lg font-semibold">Book Appointment</p>
                <Link to="/contact">
                  <Button 
                    variant="secondary" 
                    size="sm"
                    className="mt-2"
                  >
                    Click Here
                  </Button>
                </Link>
              </div>
            </div>
          </div>

          <div className="flex flex-col sm:flex-row gap-4 justify-center">
            <Link to="/contact">
              <Button 
                size="lg" 
                className="bg-teal-500 hover:bg-teal-600 text-white px-8 py-4 text-lg"
              >
                Book Your Appointment Today
              </Button>
            </Link>
            <Button variant="outline" size="lg" className="border-white text-white hover:bg-white hover:text-teal-600 px-8 py-4 text-lg">
              <a href="https://wa.me/916369090441" target="_blank" rel="noopener noreferrer" className="flex items-center">
                <i className="ri-whatsapp-line mr-2"></i>
                WhatsApp Us
              </a>
            </Button>
          </div>
        </div>
      </section>
    </div>
  );
}
